<form
  [formGroup]="exportationBatchForm"
  (ngSubmit)="saveExportationBatch()"
  autocomplete="on"
  class="container-grid"
>
  <div class="grid-first" *ngIf="!currentPath.includes('/batch-create')">
    <label for="noLote" class="form-label">No. de lote*</label>
    <input type="text" id="noLote" class="form-control" [value]="bachId" disabled>
  </div>
  <div>
    <label for="lote-cliente" class="form-label"
      >Nombre del lote</label
    >
    <input
      type="text"
      id="lote-cliente"
      class="form-control"
      formControlName="customer_lot_number"
      maxlength="100"
    />
  </div>
  <div class="">
    <label for="bl-lote" class="form-label">BL lote</label>
    <input
      type="text"
      id="bl-lote"
      class="form-control"
      maxlength="20"
      formControlName="bl_lot_id"
    />
    <span class="form-text text-danger" *ngIf="isValidField('bl_lot_id')">
      Ingrese el BL lote*
    </span>
  </div>
  <div class="grid-first">
    <label for="cliente" class="form-label">Cliente*</label>
    <select
      id="cliente"
      class="form-control"
      formControlName="customer_id"
    >
      <option value="">-- Seleccione el Cliente --</option>
      <option *ngFor="let customer of customers" [value]="customer.id">
        {{ customer.name }}
      </option>
    </select>
    <span class="form-text text-danger" *ngIf="isValidField('customer_id')">
      Seleccione el cliente
    </span>
  </div>
  <div *ngIf="!currentPath.includes('/batch-detail')">
    <label for="cliente-razon-social" class="form-label">
      Cliente razón social*
    </label>
    <select
      name=""
      id="cliente-razon-social"
      class="form-control"
      formControlName="id_business_name"
      (change)="changeRazonSocial()"
    >
      <option value="">-- Seleccione el Cliente razón social --</option>
      <option
        *ngFor="let customer of customersBusinessName"
        [value]="customer.id_business_name"
      >
        {{ customer.business_name }}
      </option>
    </select>
    <span
      class="form-text text-danger"
      *ngIf="isValidField('id_business_name')"
    >
      Seleccione una razón social
    </span>
  </div>
  <div *ngIf="currentPath.includes('/batch-detail')">
    <label for="cliente-razon-social" class="form-label">
      Cliente razón social*
    </label>
    <input
      type="text"
      id="cliente-razon-social"
      class="form-control"
      [value]="client_name"
      disabled
    >
  </div>
  <div class="grid-span2">
    <label for="domicilio" class="form-label">Domicilio*</label>
    <input
      type="text"
      id="domicilio"
      class="form-control"
      formControlName="address_business"
      maxlength="200"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('address_business')"
    >
      Ingrese un domicilio*
    </span>
  </div>
  <div class="grid-first">
    <label for="grupo-material" class="form-label">Grupo de material*</label>
    <select
      name=""
      id="grupo-material"
      class="form-control"
      formControlName="material_group_id"
    >
      <option value="">-- Seleccione el Grupo de material --</option>
      <option
        *ngFor="let materialGroup of materialGroups"
        [value]="materialGroup.id"
      >
        {{ materialGroup.description }}
      </option>
    </select>
    <span class="form-text text-danger" *ngIf="isValidField('material_group_id')">
      Seleccione el grupo de material
    </span>
  </div>
  <div *ngIf="!currentPath.includes('/batch-detail')">
    <label for="nombre-material" class="form-label">
      Nombre del material*
    </label>
    <select
      name=""
      id="nombre-material"
      class="form-control"
      formControlName="material_id"
    >
      <option value="">-- Seleccione el material --</option>
      <option *ngFor="let material of materials" [value]="material.id">
        {{ material.description }}
      </option>
    </select>
    <span class="form-text text-danger" *ngIf="isValidField('material_id')">
      Selecciona un nombre de material
    </span>
  </div>
  <div *ngIf="currentPath.includes('/batch-detail')">
    <label for="material" class="form-label">
      Nombre del material*
    </label>
    <input
      type="text"
      id="material"
      class="form-control"
      [value]="exportationBatch.material_name"
      disabled
    >
  </div>
  <div class="">
    <label for="origin" class="form-label">Origen*</label>
    <input
      type="text"
      id="origin"
      class="form-control"
      maxlength="50"
      formControlName="origin"
    />
    <span class="form-text text-danger" *ngIf="isValidField('origin')">
      Ingrese el origen
    </span>
  </div>
  <div class="grid-first">
    <label for="embalaje" class="form-label">Embalaje*</label>
    <select
      name=""
      id="embalaje"
      class="form-control"
      formControlName="packing_id"
      (change)="changePacking()"
    >
      <option value="">-- Seleccione el Embalaje --</option>
      <option *ngFor="let packaging of packagings" [value]="packaging.id">
        {{ packaging.description }}
      </option>
    </select>
    <span class="form-text text-danger" *ngIf="isValidField('packing_id')">
      Selecciona un embalaje
    </span>
  </div>
  <div class="grid-span2">
    <label for="observaciones" class="form-label">Observaciones</label>
    <input
      type="text"
      id="observaciones"
      class="form-control"
      formControlName="observations"
      maxlength="300"
    />
  </div>
  <div class="grid-first">
    <label for="valorComercial_lote_cabotaje" class="form-label">Valor comercial</label>
    <input
      type="text"
      id="valorComercial_lote_cabotaje"
      class="form-control"
      formControlName="commercial_value"
      appBlockLetters
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('commercial_value')"
    >
      Ingresa el valor comercial valido
    </span>
  </div>
  <div class="grid-first">
    <label for="tonelaje" class="form-label">Tonelaje*</label>
    <input
      type="number"
      id="tonelaje"
      class="form-control"
      formControlName="tonnage"
      min="0"
    />
    <span
      class="form-text text-danger"
      *ngIf="
      exportationBatchForm.get('tonnage')?.hasError('required') &&
        exportationBatchForm.get('tonnage')!.touched
      "
    >
      Ingresa un tonelaje valido
    </span>
    <span
      class="form-text text-danger"
      *ngIf="exportationBatchForm.get('tonnage')?.hasError('pattern')"
    >
      Ingresa un tonelaje positivo y con máximo tres decimales
    </span>
  </div>
  <div>
    <label for="cantidad-piezas" class="form-label">
      Piezas totales{{asterico}}
    </label>
    <input
      type="text"
      id="cantidad-piezas"
      class="form-control"
      appOnlyNumbers
      [maxDigits]="10"
      formControlName="quantity_pieces"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('quantity_pieces')"
    >
      Ingresa cantidad de piezas valida y sin decimales
    </span>
  </div>
  <div class="grid-first">
    <label for="dias-libres" class="form-label">
      Días libres de almacenaje*
    </label>
    <input
      type="number"
      id="dias-libres"
      class="form-control"
      formControlName="days_free_storage"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('days_free_storage')"
    >
      Ingresa el número de días válido
    </span>
  </div>
  <div>
    <label for="tarifa-almacenaje" class="form-label">
      Tarifa de almacenaje*
    </label>
    <input
      type="number"
      id="tarifa-almacenaje"
      class="form-control m-0"
      formControlName="storage_fee"
      min="0"
    />
    <span class="form-text text-danger" *ngIf="isValidField('storage_fee')">
      Ingresa la tarifa de almacenaje valida
    </span>
  </div>
  <div>
    <label for="tarifaEspecialAlmacenaje" class="form-label">
      Tarifa especial de almacenaje*
    </label>
    <input
      type="text"
      id="tarifaEspecialAlmacenaje"
      class="form-control"
      formControlName="special_storage_rate"
      appBlockLetters
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('special_storage_rate')"
    >
      Ingresa la tarifa especial de almacenaje
    </span>
  </div>
  <div class="grid-first">
    <label *ngIf="!currentPath.includes('/batch-detail')" for="fileBatch" class="form-label">
      Documento de BL
    </label>
    <p *ngIf="currentPath.includes('/batch-detail')" class="form-label">
      Documento de BL
    </p>
    <input
      type="file"
      accept=".pdf"
      id="fileBatch"
      class="form-control"
      (change)="fileInputSimple($event, 'file_cabotage_batch')"
      *ngIf="!currentPath.includes('/batch-detail')"
    />
    <a
      *ngIf="!currentPath.includes('/batch-create') && file.url"
      [href]="file.url"
      target="_blank"
      class="form-control fileUrl mt-2"
      >Descargar Archivo</a
    >
    <p class="form-control fileUrl" *ngIf="currentPath.includes('/batch-detail') && !file.url">Sin archivo</p>
    <span
      class="form-text text-danger"
      *ngIf="isValidField('file_cabotage_batch') && currentPath.includes('/batch-create')"
    >
      {{ mensajeError2 }}
    </span>
    <span
      class="form-text text-danger"
      *ngIf="maxSize2"
    >
      {{ mensajeError2 }}
    </span>
  </div>
  <div class="grid-first">
    <label for="embarRecibidor" class="form-label">
      Embarcador/Recibidor
    </label>
    <input
      type="text"
      id="embarRecibidor"
      class="form-control"
      formControlName="shipper_receiver"
      maxlength="100"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('shipper_receiver')"
    >
      Ingresa el Embarcador/Recibidor
    </span>
  </div>
  <div>
    <label for="domicilioEmbarqueRecibidor" class="form-label">
      Domicilio del Embarcador/Recibidor
    </label>
    <input
      type="text"
      id="domicilioEmbarqueRecibidor"
      class="form-control"
      formControlName="address_shipper_receiver"
      maxlength="150"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('address_shipper_receiver')"
    >
      Ingresa el domicilio
    </span>
  </div>
  <div class="grid-first">
    <label for="nombreConsignatario" class="form-label">
      Nombre del consignatario
    </label>
    <input
      type="text"
      id="nombreConsignatario"
      class="form-control"
      formControlName="consignee_name"
      maxlength="100"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('consignee_name')"
    >
      Ingrese el nombre
    </span>
  </div>
  <div class="grid-span2">
    <label for="domicilioConsignatario" class="form-label">
      Domicilio del consignatario
    </label>
    <input
      type="text"
      id="domicilioConsignatario"
      class="form-control"
      formControlName="address_consignee"
      maxlength="150"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('address_consignee')"
    >
      Ingrese el domicilio del consignatario
    </span>
  </div>
  <div class="grid-span2">
    <label for="invoiceUuid" class="form-label">
      UUID de la factura
    </label>
    <input
      type="text"
      id="invoiceUuid"
      class="form-control"
      formControlName="invoice_uuid"
      maxlength="36"
    />
  </div>
  <div class="grid-first">
    <label *ngIf="!currentPath.includes('/batch-detail')" for="anexo1" class="form-label">
      Carga de anexo 1
    </label>
    <p *ngIf="currentPath.includes('/batch-detail')" class="form-label">
      Carga de anexo 1
    </p>
    <input
      type="file"
      accept=".pdf"
      id="anexo1"
      class="form-control"
      (change)="fileAnnex($event, 0)"
      *ngIf="!currentPath.includes('/batch-detail')"
    />
    <a
      *ngIf="!currentPath.includes('/batch-create') && annexUrls[0]"
      [href]="annexUrls[0]"
      target="_blank"
      class="form-control fileUrl"
      >Descargar Archivo</a
    >
    <p class="form-control fileUrl" *ngIf="currentPath.includes('/batch-detail') && !annexUrls[0]">Sin archivo</p>
    <span
      class="form-text text-danger"
      *ngIf="maxSizeAnnex1"
    >
      {{ errorAnnex1 }}
    </span>
  </div>
  <div>
    <label *ngIf="!currentPath.includes('/batch-detail')" for="anexo2" class="form-label">
      Carga de anexo 2
    </label>
    <p *ngIf="currentPath.includes('/batch-detail')" class="form-label">
      Carga de anexo 2
    </p>
    <input
      type="file"
      accept=".pdf"
      id="anexo2"
      class="form-control"
      (change)="fileAnnex($event, 1)"
      *ngIf="!currentPath.includes('/batch-detail')"
    />
    <a
      *ngIf="!currentPath.includes('/batch-create') && annexUrls[1]"
      [href]="annexUrls[1]"
      target="_blank"
      class="form-control fileUrl"
      >Descargar Archivo</a
    >
    <p class="form-control fileUrl" *ngIf="currentPath.includes('/batch-detail') && !annexUrls[1]">Sin archivo</p>
    <span
      class="form-text text-danger"
      *ngIf="maxSizeAnnex2"
    >
      {{ errorAnnex2 }}
    </span>
  </div>
  <div>
    <label *ngIf="!currentPath.includes('/batch-detail')" for="anexo3" class="form-label">
      Carga de anexo 3
    </label>
    <p *ngIf="currentPath.includes('/batch-detail')" class="form-label">
      Carga de anexo 3
    </p>
    <input
      type="file"
      accept=".pdf"
      id="anexo3"
      class="form-control"
      (change)="fileAnnex($event, 2)"
      *ngIf="!currentPath.includes('/batch-detail')"
    />
    <a
      *ngIf="!currentPath.includes('/batch-create') && annexUrls[2]"
      [href]="annexUrls[2]"
      target="_blank"
      class="form-control fileUrl"
      >Descargar Archivo</a
    >
    <p class="form-control fileUrl" *ngIf="currentPath.includes('/batch-detail') && !annexUrls[2]">Sin archivo</p>
    <span
      class="form-text text-danger"
      *ngIf="maxSizeAnnex3"
    >
      {{ errorAnnex3 }}
    </span>
  </div>
  <div class="grid-first">
    <label *ngIf="!currentPath.includes('/batch-detail')" for="anexo4" class="form-label">
      Carga de anexo 4
    </label>
    <p *ngIf="currentPath.includes('/batch-detail')" class="form-label">
      Carga de anexo 4
    </p>
    <input
      type="file"
      accept=".pdf"
      id="anexo4"
      class="form-control"
      (change)="fileAnnex($event, 3)"
      *ngIf="!currentPath.includes('/batch-detail')"
    />
    <a
      *ngIf="!currentPath.includes('/batch-create') && annexUrls[3]"
      [href]="annexUrls[3]"
      target="_blank"
      class="form-control fileUrl"
      >Descargar Archivo</a
    >
    <p class="form-control fileUrl" *ngIf="currentPath.includes('/batch-detail') && !annexUrls[3]">Sin archivo</p>
    <span
      class="form-text text-danger"
      *ngIf="maxSizeAnnex4"
    >
      {{ errorAnnex4 }}
    </span>
  </div>
  <div>
    <label *ngIf="!currentPath.includes('/batch-detail')" for="anexo5" class="form-label">
      Carga de anexo 5
    </label>
    <p *ngIf="currentPath.includes('/batch-detail')" class="form-label">
      Carga de anexo 5
    </p>
    <input
      type="file"
      accept=".pdf"
      id="anexo5"
      class="form-control"
      (change)="fileAnnex($event, 4)"
      *ngIf="!currentPath.includes('/batch-detail')"
    />
    <a
      *ngIf="!currentPath.includes('/batch-create') && annexUrls[4]"
      [href]="annexUrls[4]"
      target="_blank"
      class="form-control fileUrl"
      >Descargar Archivo</a
    >
    <p class="form-control fileUrl" *ngIf="currentPath.includes('/batch-detail') && !annexUrls[4]">Sin archivo</p>
    <span
      class="form-text text-danger"
      *ngIf="maxSizeAnnex5"
    >
      {{ errorAnnex5 }}
    </span>
  </div>
  <button type="button" class="grid-first btn-lote rule238" (click)="fieldsHiden()">{{ textRule238 }}</button>
  <ng-container *ngIf="rule238">
    <div
        class="grid-span4"
        formArrayName="previous_registration_sample_collection"
      >
        <p class="form-label">Registro previo de toma de muestra</p>
        <div
          class="registroPrevioContainer"
          *ngFor="
            let registro of registrosPreviosTomaMuestraArr['controls'];
            let i = index
          "
          [formGroupName]="i"
        >
          <div>
            <input
              type="text"
              class="form-control"
              name="registroMuestraOficio"
              placeholder="Número de oficio"
              formControlName="trade_number"
              appBlockLetters
            />
            <span
              class="form-text text-danger"
              *ngIf="
                arrayValido(
                  'previous_registration_sample_collection',
                  i,
                  'trade_number'
                )
              "
            >
              Ingresa el número de oficio válido
            </span>
          </div>
          <div>
            <input
              type="datetime-local"
              class="form-control"
              name="registroMuestraFecha"
              formControlName="sampling_date"
            />
            <span
              class="form-text text-danger"
              *ngIf="
                dateValid(
                  'previous_registration_sample_collection',
                  i,
                  'sampling_date',
                  'required'
                )
              "
            >
              Ingresa la fecha
            </span>
            <span
              class="form-text text-danger"
              *ngIf="
                dateValid(
                  'previous_registration_sample_collection',
                  i,
                  'sampling_date',
                  'dateValid'
                )
              "
            >
              La fecha debe ser posterior a la fecha de atraque({{ blDetails.docking_date }})
            </span>
          </div>
          <div>
            <input
              type="number"
              class="form-control"
              name="registroMuestraPeso"
              placeholder="Peso de la toma de muestra"
              formControlName="sample_weight"
            />
            <span
              class="form-text text-danger"
              *ngIf="
                arrayValido(
                  'previous_registration_sample_collection',
                  i,
                  'sample_weight'
                )
              "
            >
              Ingresa el peso valido
            </span>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn-lote btn-registro grid-first"
        (click)="agregarFormGroup('registro')"
        *ngIf="!currentPath.includes('/batch-detail')"
      >
        Agregar registro
      </button>
      <button
        type="button"
        class="btn-lote btn-registro"
        (click)="eliminarFormGroup('registro')"
        *ngIf="registrosPreviosTomaMuestraArr.length && !currentPath.includes('/batch-detail')"
      >
        Eliminar registro
      </button>
      <div class="grid-first">
        <label for="pama" class="form-label">
          No. PAMA
        </label>
        <input
          type="text"
          id="pama"
          class="form-control"
          formControlName="pama_number"
          maxlength="150"
        >
      </div>
      <h2 class="title grid-span4">
        Datos de facturación
      </h2>
      <div class="grid-first">
        <label for="folioFiscal" class="form-label">
          Folio fiscal CFDI
        </label>
        <input
          type="text"
          id="folioFiscal"
          class="form-control"
          formControlName="fiscal_folio_cfdi"
          maxlength="150"
        >
      </div>
      <div>
        <label for="montoCFDI" class="form-label">
          Monto total del CFDI
        </label>
        <input
          type="text"
          id="montoCFDI"
          class="form-control"
          formControlName="total_amount_cfdi"
          maxlength="150"
        >
      </div>
      <div class="grid-first-span2">
        <label for="montoPresentacion" class="form-label">
          Monto total obtenido por la prestación del servicio para el manejo, almacenaje y custodia de las mercancías
        </label>
        <input
          type="text"
          id="montoPresentacion"
          class="form-control"
          formControlName="total_amount_presentation"
          maxlength="150"
        >
      </div>
      <div class="grid-first-span2">
        <label for="cantidadMercancia" class="form-label">
          Cantidad de mercancía que se encuentra en depósito de conformidad a la unidad de medida con la que se factura el servicio prestado
        </label>
        <input
          type="text"
          id="cantidadMercancia"
          class="form-control"
          formControlName="amount_merchandise_deposit"
          maxlength="150"
        >
      </div>
      <div class="grid-first-span2">
        <label for="montoMonedaNacional" class="form-label">
          Monto correspondiente a compensación de moneda nacional
        </label>
        <input
          type="text"
          id="montoMonedaNacional"
          class="form-control"
          formControlName="compensation_amount"
          maxlength="150"
        >
      </div>
      <h2 class="title grid-span4">
        Información adicional
      </h2>
      <div class="grid-1-3">
        <label for="registroViolacionDañoExtravio" class="form-label">
          Registro de violación de daño o extravió de bultos/mercancías
        </label>
        <input
          type="text"
          id="registroViolacionDañoExtravio"
          class="form-control"
          formControlName="damage_violation_record"
          maxlength="50"
        />
      </div>
      <div class="grid-span4" formArrayName="customs_embargoed_merchandise">
        <p class="form-label">
          Mercancía que fue embargada por autoridades aduaneras
        </p>
        <div
          class="mercanciaEmbargadaAduanaContainer"
          *ngFor="
            let mercancia of mercanciasEmbargadasAduanaArr['controls'];
            let i = index
          "
          [formGroupName]="i"
        >
          <div>
            <input
              type="text"
              class="form-control"
              name="mercanciaEmbargadaOficio"
              placeholder="Número de oficio"
              formControlName="trade_number"
              appBlockLetters
            />
            <span
              class="form-text text-danger"
              *ngIf="
                arrayValido('customs_embargoed_merchandise', i, 'trade_number')
              "
            >
              Ingresa el número de oficio válido
            </span>
          </div>
          <div>
            <input
              type="datetime-local"
              class="form-control"
              name="mercanciaEmbargadaFecha"
              formControlName="office_date"
            />
            <span
              class="form-text text-danger"
              *ngIf="
                dateValid(
                  'customs_embargoed_merchandise',
                  i,
                  'office_date',
                  'required'
                )
              "
            >
              Ingresa la fecha
            </span>
            <span
              class="form-text text-danger"
              *ngIf="
                dateValid(
                  'customs_embargoed_merchandise',
                  i,
                  'office_date',
                  'dateValid'
                )
              "
            >
              La fecha debe ser posterior a la fecha de atraque({{ blDetails.docking_date }})
            </span>
          </div>
          <div>
            <input
              type="number"
              class="form-control"
              name="mercanciaEmbargadaPeso"
              placeholder="Peso de la mercancía embargada"
              formControlName="weight_embargoed_merchandise"
            />
            <span
              class="form-text text-danger"
              *ngIf="
                arrayValido(
                  'customs_embargoed_merchandise',
                  i,
                  'weight_embargoed_merchandise'
                )
              "
            >
              Ingresa el peso valido
            </span>
          </div>
          <div>
            <input
              type="file"
              accept=".pdf"
              class="form-control"
              name="mercanciaEmbargadaArchivo"
              (change)="fileInput($event, i, 'customs_embargoed_merchandise')"
              *ngIf="!filesUrl[i]"
            />
            <a
              *ngIf="filesUrl[i]"
              [href]="filesUrl[i]"
              target="_blank"
              class="form-control fileUrl"
              >Descargar Archivo</a
            >
            <span
              class="form-text text-danger"
              *ngIf="arrayValido('customs_embargoed_merchandise', i, 'file')"
            >
              {{ errorMessage }}
            </span>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn-lote btn-registro grid-first"
        (click)="agregarFormGroup('mercancia')"
        *ngIf="!currentPath.includes('/batch-detail')"
      >
        Agregar registro
      </button>
      <button
        type="button"
        class="btn-lote btn-registro"
        (click)="eliminarFormGroup('mercancia')"
        *ngIf="mercanciasEmbargadasAduanaArr.length && !currentPath.includes('/batch-detail')"
      >
        Eliminar registro
      </button>
      <div class="grid-1-3">
        <label for="mercanciaAlmacenadaAutoridad" class="form-label">
          Identificación de mercancía almacenada a solicitud de la autoridad
        </label>
        <input
          type="text"
          id="mercanciaAlmacenadaAutoridad"
          class="form-control"
          formControlName="identification_stored_merchandise"
          maxlength="100"
        />
      </div>
      <div class="grid-1-3">
        <label for="volumenMercanciaRecinto" class="form-label">
          Volumen que ocupa la mercancía en el recinto fiscalizado
        </label>
        <input
          type="text"
          id="volumenMercanciaRecinto"
          class="form-control"
          formControlName="volume_occupied_merchandise"
          appBlockLetters
        />
        <span
          class="form-text text-danger"
          *ngIf="isValidField('volume_occupied_merchandise')"
        >
          Ingresa un número válido con máximo dos decimales
        </span>
      </div>
      <div class="grid-first">
        <label for="dimensionContenedor" class="form-label">
          Dimensión del contenedor
        </label>
        <input
          type="text"
          id="dimensionContenedor"
          class="form-control"
          formControlName="container_dimension"
          maxlength="150"
        >
      </div>
      <div>
        <label for="tipoContenedor" class="form-label">
          Tipo de contenedor
        </label>
        <input
          type="text"
          id="tipoContenedor"
          class="form-control"
          formControlName="container_type"
          maxlength="150"
        >
      </div>
      <div>
        <label for="numeroSellosContenedor" class="form-label">
          Número de sellos del contenedor
        </label>
        <input
          type="text"
          id="numeroSellosContenedor"
          class="form-control"
          formControlName="number_container_seals"
          maxlength="150"
        >
      </div>
      <div class="grid-first">
        <label for="candadosContenedor" class="form-label">
          No. de candados del contenedor
        </label>
        <input
          type="text"
          id="candadosContenedor"
          class="form-control"
          formControlName="number_container_locks"
          maxlength="150"
        >
      </div>
      <div class="grid-first">
        <label for="contenedorDesconsolidado" class="form-label">
          Contenedor desconsolidado
        </label>
        <input
          type="text"
          id="contenedorDesconsolidado"
          class="form-control"
          formControlName="unconsolidated_container"
          maxlength="150"
        >
      </div>
      <div>
        <label for="almacenDesconsolidado" class="form-label">
          Almacén desconsolidado
        </label>
        <input
          type="text"
          id="almacenDesconsolidado"
          class="form-control"
          formControlName="deconsolidated_store"
          maxlength="150"
        >
      </div>
      <div>
        <label for="medioTransporteDesconsolidado" class="form-label">
          Medio de transporte desconsolidado
        </label>
        <input
          type="text"
          id="medioTransporteDesconsolidado"
          class="form-control"
          formControlName="unconsolidated_means_transport"
          maxlength="150"
        >
      </div>
      <div class="grid-first">
        <label for="contenedorConsolidado" class="form-label">
          Contenedor consolidado
        </label>
        <input
          type="text"
          id="contenedorConsolidado"
          class="form-control"
          formControlName="consolidated_container"
          maxlength="150"
        >
      </div>
      <div>
        <label for="almacenConsolidado" class="form-label">
          Almacén consolidado
        </label>
        <input
          type="text"
          id="almacenConsolidado"
          class="form-control"
          formControlName="consolidated_store"
          maxlength="150"
        >
      </div>
      <div>
        <label for="medioTransporteConsolidado" class="form-label">
          Medio de transporte consolidado
        </label>
        <input
          type="text"
          id="medioTransporteConsolidado"
          class="form-control"
          formControlName="consolidated_means_transport"
          maxlength="150"
        >
      </div>
  </ng-container>
  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="goBack()"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="!currentPath.includes('/batch-detail')"
    >
      Guardar
    </button>
  </div>
</form>
<app-overlay
  *ngIf="overlay"
  [icono]="icono"
  [mensaje]="mensaje"
  [buttons]="buttons"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
